import React from 'react'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import {
  $DCprimaryColor,
  DcButton,
  DcOverlaySlider,
  PixelDate,
  PixelIcon,
  PixelTag,
  PixelText,
} from 'pixel-base'
import styled from 'styled-components'

import EditStoreAdditionalInfo from './subComponents/EditStoreAdditionalInfo'
import { OrderDetail } from '../../../../../decl'
interface IProps {
  details: OrderDetail
  detailID: number
  setDetails: (details: OrderDetail) => void
  newOrder: boolean
  newOrderData: OrderDetail
  setNewOrderData: (newOrderData: OrderDetail) => void
  isItInvoice: boolean
}
const StoreOrder = (props: IProps) => {
  const {
    details,
    detailID,
    setDetails,
    newOrder,
    newOrderData,
    setNewOrderData,
  } = props
  const [showAddProductPopup, setShowAddProductPopup] = React.useState(false)

  return (
    <Container>
      <InnerSection>
        <SectionHeader>
          <PixelText
            textSize="16px"
            color="rgba(0, 0, 0, 0.84)"
            style={{ fontWeight: '600', padding: '10px' }}
          >
            Additional Info
          </PixelText>
          {details?.is_editable === true && (
            <CloseButton>
              <DcButton
                size="sm"
                variant="link"
                onClick={() => {
                  setShowAddProductPopup(true)
                }}
              >
                <PixelIcon
                  icon={faPencilAlt}
                  showTooltip
                  tooltip="Edit"
                  color={$DCprimaryColor}
                />
              </DcButton>
            </CloseButton>
          )}
        </SectionHeader>
        {newOrder ? (
          <>
            <EditStoreAdditionalInfo
              handleClose={() => {
                setShowAddProductPopup(false)
              }}
              details={details}
              detailID={detailID}
              setDetails={setDetails}
              newOrderData={newOrderData}
              setNewOrderData={setNewOrderData}
              newOrder={newOrder}
            />
          </>
        ) : (
          <>
            {details && (
              <>
                <InnerSection>
                  <InnerSectionContent>
                    <StandardText>
                      Store:&nbsp;
                      <strong>{details?.store_name}</strong>
                    </StandardText>
                    <StandardText>
                      Order ID:&nbsp;
                      <strong>{details?.number}</strong>
                    </StandardText>
                    <StandardText>
                      Dispatch ID:&nbsp;
                      <strong>{details?.dispatch_id}</strong>
                    </StandardText>
                    <StandardText>
                      Order Source:&nbsp;
                      <PixelTag>{details?.meta?.order_source}</PixelTag>
                    </StandardText>
                    <StandardText>
                      Added by:&nbsp;
                      <strong>{details?.meta?.added_by}</strong>
                    </StandardText>
                    <StandardText>
                      Received at:&nbsp;
                      <strong>
                        <PixelDate
                          className="textSmall"
                          value={details?.date_created}
                          format={'dateWithTime'}
                        />
                      </strong>
                    </StandardText>
                  </InnerSectionContent>
                </InnerSection>
              </>
            )}
          </>
        )}

        <DcOverlaySlider
          width="50%"
          title={'Edit Additional Info'}
          isOpen={showAddProductPopup}
          onClose={() => setShowAddProductPopup(false)}
        >
          {showAddProductPopup && (
            <EditStoreAdditionalInfo
              handleClose={() => {
                setShowAddProductPopup(false)
              }}
              details={details}
              detailID={detailID}
              setDetails={setDetails}
              newOrderData={newOrderData}
              setNewOrderData={setNewOrderData}
              newOrder={newOrder}
            />
          )}
        </DcOverlaySlider>
      </InnerSection>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
const InnerSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  border-bottom: 1px solid #e6e6e6;
  width: 100%;
`
const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: 7px;
`

const CloseButton = styled.div`
  /* padding: 10px; */
  margin-right: 8px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.84);
  font-size: 20px;
  font-weight: 600;
  &:hover {
    color: rgba(0, 0, 0, 0.87);
  }
`

const InnerSectionContent = styled.div<{ direction?: boolean; gap?: string }>`
  display: flex;
  flex-direction: ${(props) => (props.direction ? 'row' : 'column')};
  gap: ${(props) => props.gap};
  margin: 10px;
`
const StandardText = styled.div<{ color?: string }>`
  display: inline-flex;
  font-size: 12px;
  font-weight: 400;
  color: ${(props) =>
    props.color === 'primary' ? $DCprimaryColor : 'rgba(0, 0, 0, 0.87)'};
`

export default StoreOrder
